import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleIcon, MicrosoftIcon, AppleIcon, SlackIcon } from './AuthIcons';
import { useAuth } from './AuthContext';
export function SignUp() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {
    signUp
  } = useAuth();
  const handleEmailSignUp = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await signUp(email);
      navigate('/register', {
        state: {
          email
        }
      });
    } catch (error) {
      console.error('Error signing up:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSocialSignUp = async (provider: string) => {
    setIsLoading(true);
    try {
      const socialEmail = `user@${provider.toLowerCase()}.com`;
      await signUp(socialEmail);
      navigate('/register', {
        state: {
          email: socialEmail,
          provider
        }
      });
    } catch (error) {
      console.error('Error with social sign up:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSignIn = () => {
    navigate('/signin');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-175">
      <div className="max-w-md w-full" data-id="element-176">
        <div className="text-center mb-12" data-id="element-177">
          <img src="https://cdn.magicpatterns.com/uploads/ssm8opUN7FjpcwsqK5Tnq3/accrue_logo.png" alt="Accrue" className="h-32 mx-auto mb-12" data-id="element-178" />
          <h1 className="text-4xl font-bold mb-2" data-id="element-179">Sign Up</h1>
          <p className="text-gray-600" data-id="element-180">
            Join the MGA Portal for feasibility study
          </p>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 mb-6" data-id="element-181">
          <div className="mb-8" data-id="element-182">
            <h2 className="text-2xl font-semibold mb-6" data-id="element-183">Create your account</h2>
            <form onSubmit={handleEmailSignUp} data-id="element-184">
              <div className="mb-4" data-id="element-185">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-186">
                  Work email
                </label>
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" className="w-full p-3 border border-gray-300 rounded-md" required data-id="element-187" />
              </div>
              <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition duration-150 ease-in-out" disabled={isLoading} data-id="element-188">
                {isLoading ? 'Processing...' : 'Sign up'}
              </button>
            </form>
          </div>
          <div className="relative mb-6" data-id="element-189">
            <div className="absolute inset-0 flex items-center" data-id="element-190">
              <div className="w-full border-t border-gray-300" data-id="element-191"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-192">
              <span className="px-2 bg-white text-gray-500" data-id="element-193">
                Or continue with
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3" data-id="element-194">
            <button onClick={() => handleSocialSignUp('google')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-195">
              <GoogleIcon data-id="element-196" />
            </button>
            <button onClick={() => handleSocialSignUp('microsoft')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-197">
              <MicrosoftIcon data-id="element-198" />
            </button>
            <button onClick={() => handleSocialSignUp('apple')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-199">
              <AppleIcon data-id="element-200" />
            </button>
            <button onClick={() => handleSocialSignUp('slack')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-201">
              <SlackIcon data-id="element-202" />
            </button>
          </div>
        </div>
        <div className="text-center" data-id="element-203">
          <p className="text-gray-600" data-id="element-204">
            Already have an account?{' '}
            <button onClick={handleSignIn} className="text-blue-600 hover:text-blue-800 font-medium" data-id="element-205">
              Sign in
            </button>
          </p>
        </div>
      </div>
    </div>;
}